export enum ToastMessage {
  COPIED_TO_CLIPBOARD = 'Copied to clipboard',
}
